import CoreEvents from '../../events';
import { classes } from './config';

export default class Checkbox {
  static selector = '[data-comp-vehicle-comparison-checkbox]';

  listenersAttached = false;

  constructor(containerEl) {
    this.container = containerEl;
    this.groupSlug = containerEl.dataset.groupSlug;
    this.stockId = containerEl.dataset.stockId;
  }

  disable() {
    this.container.setAttribute('aria-disabled', true);
  }

  disabled() {
    return this.container.ariaDisabled === 'true';
  }

  enable() {
    this.container.setAttribute('aria-disabled', false);
  }

  select(dispatchEvent = true) {
    const event = new CoreEvents.VehicleAdded(this.stockId);
    this.selected = true;

    if (dispatchEvent) {
      window.dispatchEvent(event);
    }
  }

  deselect(dispatchEvent = true) {
    const event = new CoreEvents.VehicleRemoved(this.stockId);
    this.selected = false;

    if (dispatchEvent) {
      window.dispatchEvent(event);
    }
  }

  get selected() {
    return this.container.dataset.selected === 'true';
  }

  set selected(bool) {
    this.container.dataset.selected = bool;
  }

  hide() {
    this.container.classList.add(classes.hide);
  }

  show() {
    this.container.classList.remove(classes.hide);
  }

  handleClick() {
    if (this.disabled()) return;

    if (this.selected) {
      this.deselect();
      return;
    }

    this.select();
  }

  attachListeners() {
    if (this.listenersAttached) return;

    this.container.addEventListener('click', this.handleClick.bind(this));
    this.listenersAttached = true;
  }

  mount() {
    this.attachListeners();
  }
}
